import {Buffer} from 'buffer';
import config from '../config.js'
/**
 * Userstate im sessionStorage festhalten
 * Verwendete Elemente sind
 * 'eonFilters' - die gesetzten Filter
 * 'eonSorting' - die gesetzte Sortierung
 * 'eonArticleNr' - im Suchfeld eingegebene Modelnummer
 * 'eonItemsperpage' - Zuletzt auf der Seite angezeigte Anzahl der Items
 * 'eonLastItemVisited' - ID/Artikelnummer des zuletzt besuchten Produkts
 * @returns {{getEonUserstate: ((function(*): (*|null))|*), initEonUserstate: initEonUserstate, setEonUserstate: setEonUserstate}}
 */
export function eonUserState() {
    const storageName = "eonUserstate"

    /**
     * Userstateobjekt aus der Session holen
     * @returns {{}} - Userstateobjekt
     */
    function loadSessionObject() {
        const sessionData = sessionStorage.getItem(storageName)
        let sessionObject = {}
        // wenn Daten im Userstate gespeichert wurden...
        if(sessionData) {
            try {
                // ... base64 Decodierung ....
                const buff = new Buffer(sessionData, 'base64');
                const json = buff.toString('utf8');
                // .. Objekt aus dem JSON-String
                sessionObject = JSON.parse(json)
            } catch (e) {
                console.log(e)
            }
        }
        return sessionObject
    }

    /**
     * Userstate-Objekt in der Session speichern
     * @param sessionObject
     */
    function storeSessionObject(sessionObject) {
        // Speichern, nur dann, wenn useSessionStore in der Config 'true' ist
        if(config.useSessionStore) {
            // Objekt als String Base64 encoden...
            const sessionData = Buffer(JSON.stringify(sessionObject)).toString('base64')
            // ...und speichern
            sessionStorage.setItem(storageName,sessionData)
        }
    }

    /**
     * Eintrag im Userstate holen
     * @param key
     * @returns {null|*}
     */
    const getEonUserstate = (key) => {
        const sessionObject =  loadSessionObject()
        if (key in sessionObject) {
            return sessionObject[key]
        } else {
            return null
        }
    }
    /**
     * Eintrag im Userstate setzen
     * @param key
     * @param value
     */
    const setEonUserstate = (key, value) => {
        let sessionObject = loadSessionObject()
        sessionObject[key] = value
        storeSessionObject(sessionObject)
    }
    /**
     * Initi
     */
    const initEonUserstate = () => {
        const [pageNav]  = window.performance.getEntriesByType("navigation")
        if(pageNav.type === 'navigate') {
            sessionStorage.removeItem(storageName)
        }

    }
    return {
        initEonUserstate,
        getEonUserstate,
        setEonUserstate
    }
}

